import angular from 'angular';
import Cookies from "cookies-js";

class CookiesService {
    constructor(CONFIG) {
        'ngInject';
        this.CONFIG = CONFIG;
        this.configCookies = CONFIG.cookies;
    }
    isValidCookie(cookie, objectUserCookieConsent){

        if (this.configCookies.performance.includes(cookie)) {
            return objectUserCookieConsent.hasOwnProperty('performance') && objectUserCookieConsent.performance;
        }

        if (this.configCookies.targeting.includes(cookie)) {
            return (objectUserCookieConsent.hasOwnProperty('marketing') && objectUserCookieConsent.marketing)
                || (objectUserCookieConsent.hasOwnProperty('targeting') && objectUserCookieConsent.targeting);
        }

        return true;
    }
    deleteCookie(cookie) {
        Cookies.set(cookie, '', {
            expires: new Date(0).toUTCString(),
            domain: this.CONFIG.cookiesGlobalDomain
        });
    }
}

const cookiesServiceModule = angular.module('st.services.cookies', [])
    .service('cookiesService', CookiesService)
    .name;

export default cookiesServiceModule;



// WEBPACK FOOTER //
// ./client/app/services/cookies.service.js